import { render, staticRenderFns } from "./Compress.vue?vue&type=template&id=2132bcc5&"
import script from "./Compress.vue?vue&type=script&lang=js&"
export * from "./Compress.vue?vue&type=script&lang=js&"
import style0 from "./Compress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports